import { createAction } from "@reduxjs/toolkit";

export const resetAnnuityApplication = createAction("annuity/reset");
